module.exports = __webpack_public_path__ + "img/uploadedresume.3fd91434.svg";